export enum BrowseTypesEnum {
  Video = 'video',
  GpsTrack = 'gps-track',
  Workout = 'workout',
  Coaching = 'coaching',
  Playlist = 'playlist',
}
